import { render, staticRenderFns } from "./aside-support-svg.vue?vue&type=template&id=5bbd870d&scoped=true"
import script from "./aside-support-svg.vue?vue&type=script&lang=js"
export * from "./aside-support-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd870d",
  null
  
)

export default component.exports